/* URN Format for deliveries:
 * urn:x-dc:inspera.com/grading/[assessmentRunId]/[questionId]/[partyId] => delivery tab
 * urn:x-dc:inspera.com/grading/[assessmentRunId]/[questionId] => question tab
 * urn:x-dc:inspera.com/grading/[assessmentRunId]/[partyId]/attachment/[attachmentCiId] => attachment tab
* */

export const urnService = {
    /**
     * Get a new context object from a uri parameter.
     * @param {String} urn
     * sample encoded input is urn:x-dc:inspera.com%2Fgrading%2F2374014%2F2338909%2F2374023
     * @return {Object} The new context object.
     */
    getContext(urn: string): any {
        const decodedUrn: string[] = decodeURIComponent(urn).split('/');
        const activeTab: string = this.getPaneFromUrn(urn);
        switch (activeTab) {
        case 'submission':
            return {
                questionId: parseInt(decodedUrn[3], 10),
                partyId: parseInt(decodedUrn[4], 10),
            };
        case 'questionPreview':
            return {
                questionId: parseInt(decodedUrn[3], 10),
            };
        case 'attachment':
            return {
                partyId: parseInt(decodedUrn[3], 10),
            };
        }

        return undefined;
    },
    /**
     * Get the current active pane where annotation was saved.
     * @param {String} urn
     * sample urn:x-dc:inspera.com%2Fgrading%2F2374014%2F2338909%2F2374023
     * @return {String} The active tab/pane.
     */
    getPaneFromUrn(urn: string): string {
        const decodedUrn: string[] = decodeURIComponent(urn).split('/');
        switch (decodedUrn.length) {
        case 5:
            return 'submission';
        case 4:
            return 'questionPreview';
        case 6:
            return 'attachment';
        }

        return undefined;
    },
};
